"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../Style.css");

var _WorkItem = require("./WorkItem");

var _WorkItem2 = _interopRequireDefault(_WorkItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OurWork = function OurWork(props) {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "section",
      {
        id: "ourWork",
        className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "dark" : props.theme].join(" ")
      },
      _react2.default.createElement(
        "h2",
        null,
        props.title
      ),
      _react2.default.createElement(
        "div",
        { className: "items" },
        props.ourWork.map(function (work) {
          return _react2.default.createElement(_WorkItem2.default, {
            key: work.id,
            id: work.id,
            text: work.text,
            name: work.name,
            image: work.image
          });
        })
      )
    )
  );
};

exports.default = OurWork;